exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input_container {\n    position: relative;\n    display: inline-block;\n    width : 100%;\n}\n.input_container > input {\n    padding-right: 20px;\n    width: 100%;\n}\n.input_container > label {\n    position: absolute;\n    top: 0;\n    right: 0px;\n    padding: 11px 8px;\n    font-size: .5em;\n    color: #000;\n    text-align: center;\n    width: 26px;\n}\n", ""]);

// exports
